import { useCrmSharing } from '@/services/sharing';
import { CustomerCopyPrompt } from '@/components/customers/CustomerCopyPrompt';
import { appCopyRequest } from '@/services/appCopy';
import { DemoProvider } from "@/context/DemoContext";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SignalRProvider } from "@/context/SignalRContext";
import { ThemeProvider } from "@/context/ThemeProvider";
import { AppRoutes } from "@/routes/AppRoutes";
export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <WorkspaceProviders />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

function WorkspaceProviders() {
  const { session } = useAuth();
  return (
    <SignalRProvider key={`${session?.userId}:${session?.businessId}`}>
      <DemoProvider>
        <CustomerCopyGate />
        <AppRoutes />
      </DemoProvider>
    </SignalRProvider>
  );
}

function CustomerCopyGate() {
  const sharing=useCrmSharing()
  return sharing.canCopy ? <CustomerCopyPrompt request={appCopyRequest} businessKey={sharing.businessKey} appName="CRM" /> : null
}
